import styled from 'styled-components'

import { Alert } from '@/components/ui/alert'
import { Card } from '@/components/ui/card'

export const ContentCard = styled(Card)(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray500}`,
  borderRadius: theme.border.radius['12'],
  boxShadow: 'none',
  // Note: `Card`'s `overflow: hidden` makes flex's default `min-height: auto` behave like
  // `min-height: 0` (per spec), so without this the card would just shrink to whatever its
  // flex parent (`ContentArea`) allots it and silently clip its own content instead of
  // growing to full height and letting the page scroll, as this tab wants.
  flexShrink: 0,
  height: 'auto',
}))

export const SectionHeader = styled.div(() => ({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'space-between',
  minHeight: '3.2rem',
}))

export const HeaderActions = styled.div(({ theme }) => ({
  display: 'flex',
  gap: theme.space['8'],
}))

export const TabContent = styled.div(({ theme }) => ({
  border: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  borderRadius: theme.border.radius['8'],
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
}))

// Alert defaults to `align-self: flex-start`; inside a tab it should span the full row.
export const FullWidthAlert = styled(Alert)({
  alignSelf: 'stretch',
})

export const FieldRow = styled.div(({ theme }) => ({
  '&:first-child': {
    borderTop: 'none',
  },
  alignItems: 'center',
  borderTop: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  display: 'grid',
  gap: theme.space['24'],
  gridTemplateColumns: '20rem minmax(0, 1fr)',
  minHeight: '4.8rem',
  // Note: 2px subtracted vertically to account for input border (1px each side) + FieldRow borderTop (1px)
  padding: `calc(${theme.space['8']} - 2px) ${theme.space['16']}`,
}))

export const ActionRow = styled.div(({ theme }) => ({
  alignItems: 'center',
  borderTop: `${theme.border.size['1']} solid ${theme.colors.gray400}`,
  display: 'flex',
  gap: theme.space['12'],
  padding: `${theme.space['12']} ${theme.space['16']}`,
}))

export const FieldValue = styled.span(({ theme }) => ({
  alignItems: 'center',
  color: theme.colors.black800,
  display: 'flex',
  flexWrap: 'wrap',
  fontSize: '1.4rem',
  gap: theme.space['8'],
  paddingLeft: theme.space['10'],
}))

export const OrDivider = styled.span(({ theme }) => ({
  color: theme.colors.black500,
  fontSize: '1.4rem',
}))

export const NotConnectedButtonWrapper = styled.div(() => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  maxWidth: '27.6rem',
}))

export const FobSection = styled.div(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.space['12'],
  marginTop: theme.space['20'],
}))

export const FobSectionTitle = styled.div(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.space['6'],
}))
